export const SWIPER_STATE = 'ui/SWIPER_STATE'
export const SCREEN_RESIZE = 'ui/SCREEN_RESIZE'